import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Map from './Pages/Map';
import School from './Pages/School';
function App() {
  
 

     

  return (

   
    <div className="App">
        <Router>
       <Routes>
         <Route path="/" element={<Map/>}>
         </Route>
       </Routes>
     </Router>
    <Router>
       <Routes>
         <Route exact path="/school"  element={<School/>}>
         </Route>
       </Routes>
     </Router>
  
     
    
    
    </div>
  );
}

export default App;
